import classNames from 'classnames';
import AggRatingStructuredData, { aggRatingDataAttributes } from 'components/shared/AggRatingStructuredData';
import ReviewCount from 'components/shared/ReviewCount';
import StarRating from '@alltrails/shared/denali/components/StarRating';
import CustomProvider from 'components/CustomProvider';
import * as styles from './StarRatingAndReviews.module.scss';

type Props = {
  avgRating: number;
  reviewCount: number;
  includeAggReviewMeta?: boolean;
  className?: string;
};

const StarRatingAndReviews = ({ avgRating, reviewCount, includeAggReviewMeta, className }: Props) => (
  <div className={classNames(styles.ratingAndReview, className)} {...(includeAggReviewMeta ? aggRatingDataAttributes : {})}>
    {includeAggReviewMeta && <AggRatingStructuredData rating={avgRating} reviewCount={reviewCount} />}
    <StarRating rating={avgRating} variant="simple" shouldShowRating className={styles.starRating} />
    <ReviewCount count={reviewCount} className={styles.count} />
  </div>
);

export default function StarRatingAndReviewsWrapper({ avgRating, reviewCount, includeAggReviewMeta, className }: Props) {
  return (
    <CustomProvider>
      <StarRatingAndReviews avgRating={avgRating} reviewCount={reviewCount} includeAggReviewMeta={includeAggReviewMeta} className={className} />
    </CustomProvider>
  );
}
